/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.26",
    versionName: "0.2.0-nightly.2025.11.26",
    versionChannel: "nightly",
    buildDate: "2025-11-26T00:09:02.170Z",
    commitHash: "0ca7050792c963fd5f47296fd767fc1d1d55d248",
};
